"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = exports.TabsWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.TabsWrap = styled_components_1.default.div `
  display: flex;
  padding: 4px 24px;
  border-radius: 4px;
  background-color: white;
  width: 100%;

  @media screen and (min-width: 1000px) {
    flex-direction: column;
    min-width: 290px;
    gap: 12px;
    padding: 20px;
    border-radius: 8px;
    max-width: 290px;
  }

  @media screen and (min-width: 1690px) {
    min-width: 380px;
    max-width: 380px;
  }
`;
exports.Tab = styled_components_1.default.button `
  display: flex;
  background-color: white;
  cursor: pointer;
  gap: 8px;
  width: 100%;
  padding: 8px;
  border: none;
  border-radius: 4px;
  align-items: center;
  justify-content: center;

  span {
    display: none;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #333333;
  }

  &:hover,
  &:active,
  &.active {
    background-color: #efeaff;

    span {
      color: #7b4ef8;
    }

    svg path,
    svg rect {
      stroke: #7b4ef8;
    }
  }

  @media screen and (min-width: 1000px) {
    justify-content: flex-start;
    padding: 13px 20px;

    span {
      display: inline;
    }
  }
`;
